import { createContext } from "react";

export const DepositosContext = createContext()
export const DepositosFormContext = createContext()
export const DepositosReportContext = createContext()